SetTagView = require './set-tag-view'
PopOver = require 'views/lib/pop-over'

module.exports = class AddTagView extends SetTagView
  onSubmit: (name) ->
    if name
      @model.tagList.create({ name }, wait: true)
      PopOver.popView()
    return

  viewTitleKey: 'add tag'



// WEBPACK FOOTER //
// ./app/scripts/views/organization/add-tag-view.coffee